export interface TVSeries {
  id: string;
  title: string;
  englishTitle: string;
  category: string;
  categorySlug: string;
  year: number;
  rating: number;
  episodeCount: number;
  status: '更新中' | '已完结';
  description: string;
  longDescription: string;
  director: string;
  cast: string[];
  genre: string[];
  region: string;
  language: string;
  posterImage: string;
  bannerImage: string;
  updateInfo: string;
  isHot: boolean;
  isNew: boolean;
  viewCount: number;
}

export const categories = [
  { name: '全部', slug: 'all' },
  { name: '国产剧', slug: 'chinese' },
  { name: '韩剧', slug: 'korean' },
  { name: '美剧', slug: 'american' },
  { name: '日剧', slug: 'japanese' },
  { name: '热播推荐', slug: 'hot' },
  { name: '最新上线', slug: 'new' },
];

export const tvSeriesData: TVSeries[] = [
  {
    id: '1',
    title: '长风渡',
    englishTitle: 'Destined',
    category: '国产剧',
    categorySlug: 'chinese',
    year: 2023,
    rating: 8.2,
    episodeCount: 40,
    status: '已完结',
    description: '讲述布商之女柳玉茹与纨绔子弟顾九思先婚后爱、共同成长的故事，展现了乱世中一段刻骨铭心的爱情传奇。',
    longDescription: '布商之女柳玉茹自小遭遇生母病重、庶母不慈、父亲不重视的困境，她不得已谨小慎微，做了十五年模范闺秀。不料，对婚姻抱有憧憬的她却被家里安排嫁给了名满扬州的纨绔子弟顾九思。顾九思误会柳玉茹是因为攀附权贵才嫁给他，对其嗤之以鼻。柳玉茹幡然醒悟，不能将命运系于婚姻、系于他人，于是跟随顾母学习经商之道，凭借自己的努力在商界闯出一片天地。而顾九思也在柳玉茹的影响下逐渐成长，从纨绔子弟变为有担当的朝廷重臣。两人在乱世中相互扶持、共同成长，最终实现了各自的抱负，也收获了珍贵的爱情。',
    director: '尹涛',
    cast: ['白敬亭', '宋轶', '刘学义', '张昊唯', '张睿'],
    genre: ['古装', '爱情', '励志'],
    region: '中国大陆',
    language: '汉语普通话',
    posterImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20costume%20drama%20poster%2C%20elegant%20couple%20in%20traditional%20hanfu%2C%20romantic%20drama%20atmosphere%2C%20soft%20warm%20lighting%2C%20cinematic%20composition%2C%20classical%20Chinese%20aesthetic%2C%20movie%20poster%20style%20with%20calligraphy%20title&width=400&height=560&seq=tv-changfengdu-1&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20drama%20cinematic%20banner%2C%20grand%20historical%20scene%20with%20traditional%20architecture%2C%20elegant%20couple%20walking%20through%20ancient%20city%2C%20warm%20golden%20hour%20lighting%2C%20epic%20romantic%20atmosphere%2C%20soft%20bokeh%20background&width=1600&height=600&seq=tv-changfengdu-banner&orientation=landscape',
    updateInfo: '全40集已完结',
    isHot: true,
    isNew: false,
    viewCount: 1280000,
  },
  {
    id: '2',
    title: '黑暗荣耀',
    englishTitle: 'The Glory',
    category: '韩剧',
    categorySlug: 'korean',
    year: 2023,
    rating: 9.0,
    episodeCount: 16,
    status: '已完结',
    description: '年少时遭受校园暴力的女子，精心策划了一场复仇大计，将所有加害者和旁观者一一拖入深渊。',
    longDescription: '梦想成为建筑师的女高中生文东恩，在高中时期因遭受朴涎镇和全在俊等人的校园暴力而不得不退学。多年后，她成为了朴涎镇女儿所在小学的班主任，并开始对当年的加害者和旁观者进行彻底的复仇计划。这是一部关于复仇、正义与人性的深刻故事，宋慧乔的精湛演技将角色的隐忍与决绝展现得淋漓尽致。整个复仇过程环环相扣、精妙绝伦，被誉为近年来最优秀的韩剧之一。',
    director: '安吉镐',
    cast: ['宋慧乔', '李到晛', '林智妍', '郑成日', '廉惠兰'],
    genre: ['悬疑', '复仇', '剧情'],
    region: '韩国',
    language: '韩语',
    posterImage: 'https://readdy.ai/api/search-image?query=Korean%20drama%20revenge%20thriller%20poster%2C%20mysterious%20woman%20in%20black%20dress%2C%20dark%20moody%20atmosphere%2C%20elegant%20but%20menacing%20vibe%2C%20cinematic%20portrait%2C%20dramatic%20lighting%20with%20shadows%2C%20movie%20poster%20quality&width=400&height=560&seq=tv-darkglory-2&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Korean%20drama%20cinematic%20banner%2C%20moody%20dark%20atmosphere%2C%20woman%20standing%20in%20elegant%20modern%20room%20with%20shadows%2C%20suspenseful%20thriller%20mood%2C%20high%20contrast%20dramatic%20lighting%2C%20professional%20cinematography&width=1600&height=600&seq=tv-darkglory-banner&orientation=landscape',
    updateInfo: '全16集已完结',
    isHot: true,
    isNew: false,
    viewCount: 2560000,
  },
  {
    id: '3',
    title: '莲花楼',
    englishTitle: 'Mysterious Lotus Casebook',
    category: '国产剧',
    categorySlug: 'chinese',
    year: 2023,
    rating: 8.5,
    episodeCount: 40,
    status: '已完结',
    description: '四顾门门主李相夷以相夷太剑冠绝天下，为正道武林之光，后遭人暗算重伤，隐姓埋名成为江湖游医李莲花。',
    longDescription: '十年前，四顾门门主李相夷惊才绝艳，以一手相夷太剑冠绝天下。然而在与金鸳盟盟主笛飞声的东海一战中，李相夷身负重伤，从此在江湖上销声匿迹。十年后，一名叫李莲花的游医拖着一座莲花楼行走江湖，看似无意间卷入了一桩桩离奇的案件之中。随着案件深入，李莲花的真实身份逐渐浮出水面。这是一部融合武侠、悬疑、探案元素的精彩剧集，成毅一人分饰两角，将李相夷的意气风发与李莲花的淡然从容诠释得入木三分。',
    director: '郭虎',
    cast: ['成毅', '曾舜晞', '肖顺尧', '陈都灵', '王鹤润'],
    genre: ['武侠', '悬疑', '古装'],
    region: '中国大陆',
    language: '汉语普通话',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20drama%20poster%2C%20handsome%20swordsman%20in%20flowing%20white%20robes%2C%20ancient%20Chinese%20mystery%20atmosphere%2C%20elegant%20classical%20composition%2C%20soft%20misty%20background%2C%20wuxia%20style%20movie%20poster&width=400&height=560&seq=tv-lotus-3&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Chinese%20wuxia%20drama%20cinematic%20banner%2C%20misty%20mountain%20landscape%20with%20ancient%20Chinese%20architecture%2C%20mysterious%20atmosphere%2C%20flowing%20silk%20robes%20in%20wind%2C%20ethereal%20golden%20light%2C%20epic%20martial%20arts%20cinematography&width=1600&height=600&seq=tv-lotus-banner&orientation=landscape',
    updateInfo: '全40集已完结',
    isHot: true,
    isNew: false,
    viewCount: 1890000,
  },
  {
    id: '4',
    title: '眼泪女王',
    englishTitle: 'Queen of Tears',
    category: '韩剧',
    categorySlug: 'korean',
    year: 2024,
    rating: 8.7,
    episodeCount: 16,
    status: '已完结',
    description: '百货女王洪海仁与超市王子白贤宇，一对财阀夫妻在婚姻危机中重新发现爱情的故事。',
    longDescription: '洪海仁是女王集团百货公司的社长，她精明干练、雷厉风行，在商场上所向披靡。白贤宇是龙头超市的社长，两人结婚三年，婚姻已经走到了危险的边缘。当洪海仁被诊断出患有罕见疾病，只剩下三个月的生命时，她与白贤宇的婚姻迎来了转机。在共同面对生死考验的过程中，两人重新审视彼此的感情，发现埋藏在心底深处最真挚的爱意。金秀贤与金智媛的精湛演技让这段爱情故事催人泪下，收视率屡创新高。',
    director: '张英宇',
    cast: ['金秀贤', '金智媛', '朴成焄', '郭东延', '李主傧'],
    genre: ['爱情', '剧情', '喜剧'],
    region: '韩国',
    language: '韩语',
    posterImage: 'https://readdy.ai/api/search-image?query=Korean%20romantic%20drama%20poster%2C%20elegant%20couple%20in%20modern%20luxury%20setting%2C%20emotional%20romance%20atmosphere%2C%20soft%20warm%20lighting%2C%20cinematic%20portrait%20of%20man%20and%20woman%2C%20melodramatic%20mood%2C%20k-drama%20style&width=400&height=560&seq=tv-queentears-4&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Korean%20romance%20drama%20cinematic%20banner%2C%20luxurious%20modern%20interior%20with%20emotional%20couple%2C%20warm%20golden%20sunset%20light%20through%20large%20windows%2C%20elegant%20atmosphere%2C%20romantic%20melodrama%20cinematography&width=1600&height=600&seq=tv-queentears-banner&orientation=landscape',
    updateInfo: '全16集已完结',
    isHot: true,
    isNew: false,
    viewCount: 3120000,
  },
  {
    id: '5',
    title: '庆余年 第二季',
    englishTitle: 'Joy of Life Season 2',
    category: '国产剧',
    categorySlug: 'chinese',
    year: 2024,
    rating: 8.9,
    episodeCount: 36,
    status: '已完结',
    description: '范闲从北齐归来后，发现自己卷入了一场更大的阴谋之中，京都的暗流涌动，各方势力蠢蠢欲动。',
    longDescription: '范闲从北齐归来，本以为可以过上平静的生活，却发现自己已经卷入了一场更大的阴谋之中。二皇子与太子的斗争愈演愈烈，监察院内部暗流涌动，庆帝的态度也愈发难以捉摸。在各方势力的夹缝之中，范闲凭借自己的智慧和勇气，一步步揭开真相。张若昀再度演绎范闲，将这个角色的机智、热血与柔情完美呈现，新老演员的精彩对戏更是让整部剧看点十足。延续了第一季的高品质制作，第二季在剧情深度和人物塑造上更进一步。',
    director: '孙皓',
    cast: ['张若昀', '李沁', '陈道明', '吴刚', '郭麒麟'],
    genre: ['古装', '权谋', '玄幻'],
    region: '中国大陆',
    language: '汉语普通话',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20poster%2C%20handsome%20man%20in%20ancient%20Chinese%20official%20robes%2C%20imperial%20palace%20background%2C%20epic%20political%20intrigue%20atmosphere%2C%20dramatic%20composition%2C%20cinematic%20lighting%2C%20powerful%20presence&width=400&height=560&seq=tv-joylife-5&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20epic%20drama%20banner%2C%20grand%20ancient%20imperial%20palace%20scene%2C%20dramatic%20clouds%20and%20golden%20light%2C%20powerful%20political%20intrigue%20atmosphere%2C%20cinematic%20scale%2C%20epic%20fantasy%20aesthetic&width=1600&height=600&seq=tv-joylife-banner&orientation=landscape',
    updateInfo: '全36集已完结',
    isHot: true,
    isNew: true,
    viewCount: 4500000,
  },
  {
    id: '6',
    title: '繁花',
    englishTitle: 'Blossoms Shanghai',
    category: '国产剧',
    categorySlug: 'chinese',
    year: 2024,
    rating: 8.8,
    episodeCount: 30,
    status: '已完结',
    description: '九十年代的上海，阿宝凭借自己的智慧和魄力在商界闯出一片天地，人人争相目睹这位黄河路传奇的风采。',
    longDescription: '九十年代的上海，遍地机遇，处处生机。阿宝从平凡的市井青年，凭借敏锐的商业嗅觉和过人的胆识，在上海滩的商海中乘风破浪，成为黄河路上人人敬仰的传奇人物。在这个过程中，他与玲子、汪小姐、李李三个性格迥异的女子产生了深深的羁绊。王家卫导演首次执导电视剧，以电影级的画面质感和独特的叙事风格，将上海九十年代的繁华与沧桑展现得淋漓尽致。胡歌领衔主演，全员演技在线。',
    director: '王家卫',
    cast: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾', '游本昌'],
    genre: ['剧情', '年代', '商战'],
    region: '中国大陆',
    language: '汉语普通话、沪语',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%2C%20stylish%20man%20in%201990s%20Shanghai%20fashion%2C%20nostalgic%20golden%20atmosphere%2C%20vintage%20Shanghai%20aesthetic%2C%20warm%20neon%20lights%2C%20cinematic%20portrait%2C%20Wong%20Kar%20Wai%20style&width=400&height=560&seq=tv-blossoms-6&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20cinematic%20banner%2C%20busy%20neon%20lit%20street%20at%20night%2C%20vintage%20Chinese%20city%20atmosphere%2C%20golden%20warm%20lighting%2C%20stylish%20nostalgic%20mood%2C%20Wong%20Kar%20Wai%20aesthetic%20cinematography&width=1600&height=600&seq=tv-blossoms-banner&orientation=landscape',
    updateInfo: '全30集已完结',
    isHot: true,
    isNew: true,
    viewCount: 3980000,
  },
  {
    id: '7',
    title: '杀人者的购物中心',
    englishTitle: 'A Shop for Killers',
    category: '韩剧',
    categorySlug: 'korean',
    year: 2024,
    rating: 8.3,
    episodeCount: 8,
    status: '已完结',
    description: '失去父母后由叔叔抚养长大的郑智安，在叔叔突然去世后，发现叔叔留给她的遗产是一个神秘的购物中心。',
    longDescription: '郑智安在失去父母后，由叔叔郑镇万抚养长大。叔叔经营着一个看似普通的购物中心，却在一天突然离世。智安在整理叔叔的遗物时，发现这个购物中心隐藏着惊天的秘密——这是一家专门为杀手提供装备的秘密机构。随着各路杀手纷纷找上门来，智安必须在极短的时间内学会使用叔叔留下的武器和装备，在追杀中生存下去。李栋旭的精湛演技让这部剧集充满了紧张刺激的观感，每集都有意想不到的反转。',
    director: '李权',
    cast: ['李栋旭', '金慧埈', '朴智彬', '徐现宇', '赵汉善'],
    genre: ['动作', '悬疑', '惊悚'],
    region: '韩国',
    language: '韩语',
    posterImage: 'https://readdy.ai/api/search-image?query=Korean%20action%20thriller%20drama%20poster%2C%20mysterious%20man%20in%20black%20suit%20holding%20weapon%2C%20dark%20urban%20night%20atmosphere%2C%20intense%20neon%20lighting%2C%20stylish%20cinematic%20composition%2C%20action%20movie%20poster%20style&width=400&height=560&seq=tv-killershop-7&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Korean%20action%20thriller%20banner%2C%20dark%20urban%20night%20scene%20with%20neon%20signs%2C%20mysterious%20shopping%20mall%20interior%2C%20intense%20suspenseful%20atmosphere%2C%20stylish%20cinematography%2C%20modern%20noir%20aesthetic&width=1600&height=600&seq=tv-killershop-banner&orientation=landscape',
    updateInfo: '全8集已完结',
    isHot: false,
    isNew: true,
    viewCount: 890000,
  },
  {
    id: '8',
    title: '与凤行',
    englishTitle: 'The Legend of Shen Li',
    category: '国产剧',
    categorySlug: 'chinese',
    year: 2024,
    rating: 8.0,
    episodeCount: 39,
    status: '已完结',
    description: '魔界女王爷沈璃逃婚坠落凡间，被一位神秘的凡人行云所救，从此展开了一段跨越三界的爱恨纠葛。',
    longDescription: '灵界碧苍王沈璃为掌握自己的命运，在千岁诞辰之际逃婚，在逃婚途中被打回凤凰原形坠落凡间。重伤之际被一个名叫行云的凡人买下，两人的命运在此刻开始纠缠。然而行云并非表面上的普通凡人，他的真实身份是三界之中最尊贵的存在。当沈璃恢复真身回归灵界，两人的故事才刚刚开始。赵丽颖和林更新的再度合作让剧迷们期待已久，仙侠世界的宏大场面和精致的特效制作也让这部剧成为年度热门。',
    director: '邓科',
    cast: ['赵丽颖', '林更新', '辛云来', '何与', '李嘉琦'],
    genre: ['仙侠', '爱情', '玄幻'],
    region: '中国大陆',
    language: '汉语普通话',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%20xianxia%20fantasy%20drama%20poster%2C%20beautiful%20woman%20in%20flowing%20celestial%20robes%2C%20magical%20phoenix%20motif%2C%20ethereal%20misty%20atmosphere%2C%20soft%20dreamy%20lighting%2C%20romantic%20fantasy%20composition%2C%20elegant%20Chinese%20aesthetic&width=400&height=560&seq=tv-shenli-8&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Chinese%20xianxia%20fantasy%20drama%20banner%2C%20celestial%20heavenly%20palace%20scene%20with%20floating%20clouds%2C%20magical%20golden%20phoenix%20in%20sky%2C%20ethereal%20dreamy%20atmosphere%2C%20epic%20romantic%20fantasy%20cinematography&width=1600&height=600&seq=tv-shenli-banner&orientation=landscape',
    updateInfo: '全39集已完结',
    isHot: false,
    isNew: true,
    viewCount: 1560000,
  },
  {
    id: '9',
    title: '怪物',
    englishTitle: 'Monster',
    category: '日剧',
    categorySlug: 'japanese',
    year: 2024,
    rating: 8.6,
    episodeCount: 10,
    status: '已完结',
    description: '天才律师面对一桩看似不可能胜诉的案件，揭示出隐藏在司法系统背后令人不寒而栗的真相。',
    longDescription: '天才律师神波亮子拥有超乎常人的洞察力和推理能力，她接手了一桩看似毫无胜算的案件。被告被指控犯下了骇人听闻的罪行，但亮子凭借自己的直觉和缜密的分析，发现了案件中多处被刻意掩盖的疑点。随着调查的深入，一个涉及政商高层、跨越数十年的巨大阴谋逐渐浮出水面。趣里在剧中的表现令人惊艳，将一位不畏强权、追求正义的女律师形象刻画得入木三分。本剧剧本由知名编剧操刀，每一个案件都环环相扣，让观众欲罢不能。',
    director: '三宅喜重',
    cast: ['趣里', '杰西', '古田新太', '中村苍', '音尾琢真'],
    genre: ['律政', '悬疑', '剧情'],
    region: '日本',
    language: '日语',
    posterImage: 'https://readdy.ai/api/search-image?query=Japanese%20legal%20thriller%20drama%20poster%2C%20intense%20female%20lawyer%20in%20courtroom%2C%20dramatic%20lighting%20with%20shadows%2C%20suspenseful%20atmosphere%2C%20modern%20Tokyo%20vibe%2C%20cinematic%20portrait%2C%20dark%20moody%20composition&width=400&height=560&seq=tv-monster-jp-9&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Japanese%20drama%20cinematic%20banner%2C%20modern%20Tokyo%20cityscape%20at%20dusk%2C%20courtroom%20dramatic%20atmosphere%2C%20sophisticated%20urban%20setting%2C%20suspenseful%20mood%2C%20professional%20Japanese%20cinematography&width=1600&height=600&seq=tv-monster-jp-banner&orientation=landscape',
    updateInfo: '全10集已完结',
    isHot: false,
    isNew: true,
    viewCount: 670000,
  },
  {
    id: '10',
    title: '最后生还者',
    englishTitle: 'The Last of Us',
    category: '美剧',
    categorySlug: 'american',
    year: 2023,
    rating: 9.1,
    episodeCount: 9,
    status: '已完结',
    description: '在末日后的美国，走私者乔尔受托护送14岁的艾莉穿越废土，一段跨越末世荒野的感人旅程就此展开。',
    longDescription: '现代文明被一场席卷全球的真菌感染摧毁殆尽，幸存者们在隔离区中苟延残喘。冷硬走私者乔尔受托护送14岁的少女艾莉离开隔离区，前往抵抗组织火萤的据点。在这段横跨废土美国的旅程中，两人从最初的互相戒备到建立起深厚的羁绊，乔尔在艾莉身上找到了失去女儿的影子，而艾莉也在乔尔的保护下学会了在这个残酷世界中生存。HBO出品品质毋庸置疑，佩德罗·帕斯卡的演技和游戏原作的优秀故事完美结合，成为近年来最成功的游戏改编影视作品。',
    director: '克雷格·麦辛',
    cast: ['佩德罗·帕斯卡', '贝拉·拉姆齐', '安娜·托芙', '加布里埃尔·鲁纳'],
    genre: ['科幻', '剧情', '冒险'],
    region: '美国',
    language: '英语',
    posterImage: 'https://readdy.ai/api/search-image?query=Post%20apocalyptic%20drama%20TV%20series%20poster%2C%20rugged%20man%20and%20young%20girl%20in%20destroyed%20urban%20landscape%2C%20dramatic%20survival%20atmosphere%2C%20warm%20emotional%20bonding%20vibe%2C%20cinematic%20composition%2C%20HBO%20quality&width=400&height=560&seq=tv-lastofus-10&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Post%20apocalyptic%20cinematic%20banner%2C%20overgrown%20ruined%20cityscape%20with%20nature%20reclaiming%20buildings%2C%20warm%20sunset%20light%20through%20broken%20windows%2C%20survival%20journey%20atmosphere%2C%20HBO%20quality%20cinematography&width=1600&height=600&seq=tv-lastofus-banner&orientation=landscape',
    updateInfo: '全9集已完结',
    isHot: false,
    isNew: false,
    viewCount: 5200000,
  },
  {
    id: '11',
    title: '墨雨云间',
    englishTitle: 'The Double',
    category: '国产剧',
    categorySlug: 'chinese',
    year: 2024,
    rating: 7.8,
    episodeCount: 40,
    status: '已完结',
    description: '薛芳菲被丈夫背叛暗害后，以姜梨的身份重返京城，一步步展开复仇计划，夺回属于自己的一切。',
    longDescription: '薛芳菲本是一介县令之女，嫁入京城后本以为获得了幸福，却不料遭到了丈夫沈玉容的背叛与杀害。大难不死的她以姜梨的身份重新回到京城，在肃国公萧蘅的帮助下，一步步接近权力中心，展开了一场精心策划的复仇。吴谨言再度出演复仇大女主，将角色的坚韧、智慧与隐忍表现得淋漓尽致。剧中权谋与爱情交织，剧情反转不断，每一集都有让人意想不到的展开。',
    director: '侣皓吉吉',
    cast: ['吴谨言', '王星越', '陈鑫海', '梁永棋', '陈乔恩'],
    genre: ['古装', '复仇', '爱情'],
    region: '中国大陆',
    language: '汉语普通话',
    posterImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20revenge%20drama%20poster%2C%20beautiful%20woman%20in%20dark%20elegant%20hanfu%2C%20mysterious%20palace%20intrigue%20atmosphere%2C%20dramatic%20shadow%20and%20light%2C%20cinematic%20portrait%2C%20powerful%20female%20lead&width=400&height=560&seq=tv-inkrain-11&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Chinese%20palace%20intrigue%20drama%20banner%2C%20ancient%20imperial%20garden%20with%20blooming%20flowers%2C%20elegant%20women%20in%20traditional%20dress%2C%20dramatic%20atmosphere%2C%20soft%20spring%20lighting%2C%20romantic%20yet%20suspenseful%20mood&width=1600&height=600&seq=tv-inkrain-banner&orientation=landscape',
    updateInfo: '全40集已完结',
    isHot: false,
    isNew: true,
    viewCount: 1120000,
  },
  {
    id: '12',
    title: '死期将至',
    englishTitle: 'Death\'s Game',
    category: '韩剧',
    categorySlug: 'korean',
    year: 2024,
    rating: 8.9,
    episodeCount: 8,
    status: '已完结',
    description: '一个失败的男人在临死前与死亡做了一笔交易，他将经历12次死亡与重生，每次都会进入不同的人生。',
    longDescription: '崔益材在经历了七年的求职失败后，失去了生活的希望，选择从高楼一跃而下。但他万万没有想到，死亡并没有那么轻易地放过他。死神认为他轻视了死亡的价值，给了他一个惩罚——他将经历12次死亡与重生。每一次，他都会进入一个濒死之人的身体，体验那些人的最后时刻。如果他能在这12次人生中活下去，就能获得真正的生存机会。徐仁国和朴素丹的精彩演绎，加上每集不同的客串明星，让这部奇幻剧成为今年韩剧的最大黑马。',
    director: '河炳勋',
    cast: ['徐仁国', '朴素丹', '金智勋', '崔始源', '成勋'],
    genre: ['奇幻', '剧情', '悬疑'],
    region: '韩国',
    language: '韩语',
    posterImage: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20thriller%20drama%20poster%2C%20mysterious%20man%20falling%20through%20dark%20void%2C%20surreal%20life%20and%20death%20theme%2C%20dramatic%20contrast%20lighting%2C%20cinematic%20suspense%2C%20philosophical%20atmosphere&width=400&height=560&seq=tv-deathgame-12&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20drama%20banner%2C%20surreal%20dark%20void%20with%20floating%20lights%2C%20mysterious%20life%20and%20death%20atmosphere%2C%20dramatic%20ethereal%20lighting%2C%20philosophical%20mood%2C%20cinematic%20scale&width=1600&height=600&seq=tv-deathgame-banner&orientation=landscape',
    updateInfo: '全8集已完结',
    isHot: false,
    isNew: false,
    viewCount: 980000,
  },
];